module.exports = __webpack_public_path__ + "img/header-weddingRingsFinishes@2x.bbf2770.webp";